/**
 * @file 游戏搜索匹配工具（Layer 2 纯函数）。
 */
import type { GameInfoType } from '@/pages/dashboard/components/Navigation/GameSelector/types';

/**
 * 按名称 / 中文名 / game_code 模糊匹配游戏。
 *
 * 匹配规则与经分 GameSelector 一致：逐字符允许中间空格。
 *
 * @param game - 主版本或子版本游戏数据
 * @param searchValue - 用户输入的搜索词
 * @returns 是否匹配
 */
export const matchGameSearch = (
  game: GameInfoType,
  searchValue: string,
): boolean => {
  let { game_name: gameName, game_cn_name: gameCnName, game_code: gameCode } = game || {};
  gameName = gameName?.toLowerCase();
  gameCnName = gameCnName?.toLowerCase();
  gameCode = gameCode?.toLowerCase();
  const searchVal = searchValue?.toLowerCase();
  let searchReg = '';
  for (const char of searchVal) {
    searchReg += `${char}\\s*`;
  }
  const regex = new RegExp(searchReg, 'gi');
  return (
    regex.test(gameName || '')
    || regex.test(gameCnName || '')
    || regex.test(gameCode || '')
  );
};
